export class WidthConstants {
  public static readonly SMALL_MAX_WIDTH_CLASS: string = '';
}
